<ng-container [ngSwitch]="currentStep">
    <div class="stepper-header">
        <div class="stepper-header-title">
            <span>{{ sectionTitle }}</span>
        </div>
        <mat-progress-bar mode="determinate" [value]="progress" color="primary"></mat-progress-bar>
    </div>
    <lgv-borrower-current-address class="step-body" *ngSwitchCase="AboutYouSteps.BorrowerCurrentAddress"
        (stepChange)="goToStep($event)" (sectionChange)="goToSection($event)"></lgv-borrower-current-address>
    <lgv-borrower-citizenship class="step-body" *ngSwitchCase="AboutYouSteps.BorrowerCitizenship"
        (stepChange)="goToStep($event)" (sectionChange)="goToSection($event)"></lgv-borrower-citizenship>
    <lgv-borrower-military class="step-body" *ngSwitchCase="AboutYouSteps.BorrowerMilitary"
        (stepChange)="goToStep($event)" (sectionChange)="goToSection($event)"></lgv-borrower-military>
</ng-container>